export default {
  title: 'Portal zamówień',
  form: {
    username: {
      placeholder: 'Nazwa użytkownika',
    },
    password: {
      placeholder: 'Hasło',
    },
  },
  buttons: {
    submit: 'Zaloguj się',
  },
  toasts: {
    auth_token_invalid: 'Podany token uwierzytelniający jest nieprawidłowy, zaloguj się przy użyciu danych logowania',
    credentials_invalid: 'Nieprawidłowa nazwa użytkownika lub hasło',
  },
};
